import { useMemo } from 'react';

import { Box } from '@chakra-ui/react';

import { REVIEW_ACTIONS, REVIEW_ACTION_ITEM_TAG_MAP } from '../constant';
import { ReviewActionPlanItem } from '../types';
import { ActionListItem } from './ActionListItem';
import { AddManually } from './AddManually';
import { MavenSuggestionCard } from './MavenSuggestionCard';
import { NoActionPlan } from './NoActionPlan';

type ActionListProps = {
  reviewActionPlanItems: ReviewActionPlanItem[];
  reviewCycle: string;
  revieweeId: string;
  revieweeName: string;
  onActionSelect: (actionType: keyof typeof REVIEW_ACTIONS, actionItemId: number) => void;
  refetchActionPlanList: () => void;
};

export const ActionList = ({
  reviewActionPlanItems,
  reviewCycle,
  revieweeId,
  revieweeName,
  onActionSelect,
  refetchActionPlanList,
}: ActionListProps) => {
  const isActionPlanListAvailable = Array.isArray(reviewActionPlanItems) && reviewActionPlanItems.length > 0;

  const mavenSuggestedActionItems = useMemo(
    () => reviewActionPlanItems?.filter((actionItem) => actionItem.isMlGenerated),
    [reviewActionPlanItems]
  );

  const userCreatedActionItems = useMemo(
    () => reviewActionPlanItems?.filter((actionItem) => !actionItem.isMlGenerated),
    [reviewActionPlanItems]
  );

  if (!isActionPlanListAvailable) {
    return (
      <NoActionPlan
        reviewCycle={reviewCycle as string}
        revieweeId={revieweeId as string}
        revieweeName={revieweeName as string}
        refetchActionPlanList={refetchActionPlanList}
      />
    );
  }

  return (
    <>
      {mavenSuggestedActionItems?.length > 0 && (
        <MavenSuggestionCard
          onActionSelect={onActionSelect}
          reviewActionPlanItems={mavenSuggestedActionItems}
          reviewCycle={reviewCycle as string}
          refetchActionPlanList={refetchActionPlanList}
        />
      )}
      <Box mt={mavenSuggestedActionItems?.length > 0 ? '8px' : '0'} w="100%">
        {userCreatedActionItems.map(
          ({ id, actionItemText, isCompleted, tag, fromEmployee, isMlGenerated, isEdited }) => (
            <ActionListItem
              key={id}
              id={id}
              title={actionItemText}
              isChecked={isCompleted}
              tag={REVIEW_ACTION_ITEM_TAG_MAP[tag]}
              module={REVIEW_ACTION_ITEM_TAG_MAP[tag]}
              onActionSelect={onActionSelect}
              fromEmployee={fromEmployee || {}}
              reviewCycle={reviewCycle as string}
              refetchActionPlanList={refetchActionPlanList}
              isMlGenerated={isMlGenerated}
              isEdited={isEdited}
            />
          )
        )}
      </Box>
      <AddManually
        reviewCycle={reviewCycle as string}
        revieweeId={revieweeId as string}
        refetchActionPlanList={refetchActionPlanList}
      />
    </>
  );
};
